import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyAIJWUCzVJkm5XrbpDWUnLWVcjYthSanZs",
    authDomain: "eatwellmamav2.firebaseapp.com",
    projectId: "eatwellmamav2",
    storageBucket: "eatwellmamav2.firebasestorage.app",
    messagingSenderId: "644342362718",
    appId: "1:644342362718:web:a872113d69c53b574ffacf",
    measurementId: "G-CPJGDK8Q1W"
};

const app = initializeApp(firebaseConfig);
export const configAuth = getAuth(app);
export const storage = getStorage(app);